import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import {
//   CategoryContainer,
  Layout,
  NewProgressCard,
  NewProgressContent,
  NewProgressPoints,
  ProgressBar,
  MainProgressBar,
  PointContent,
  ImageTag,
  TrophyImg,
  TrophyLabel,
  TrophyPoints,
  Disclaimer,
} from "./newRewardDataStyles";
import { ImageUrl } from "../../utils/constants";
import { commaSeperator, fetchApi, findMonth } from "../../utils/methods";
import { Waiting } from "../../components";
import {
  getUserRewardDetails,
  // getCompanyRewardTierAPI,
} from "../../redux/actions";
import { withTranslation } from "react-i18next";
// import NewRewardCatagory from "./NewRewardCatagory";
import _ from "lodash";
import LazyImage from "../../components/common/LazyImage/LazyImage";
import { TIER_STYLES } from "../../../mockData";
import { toast } from "react-toastify";
import { GetUserRewardData, GetUsersRecentsPointsEarned } from "../../redux/constants/apiConstants";
import { TableHeader, TableRow, TableWrapper } from "./styles";
import SkeletonLoder from "../../components/common/skeletonLoder";
import dayjs from 'dayjs';


class RewardDetailsPage extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      firstIndex: 0,
      secondIndex: 0,
      rewardData: {},
      isRewardLoading: true,
      //   bucketPointsData:[],
      bucketPointsData: {
        reward_records: []
      },
      currentPage: 1,
      lastPage: 1,
      loadingMore: false,
    }
  }


  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }

  componentDidMount() {
    this.setState({
      firstIndex: 10,
      secondIndex: 5,
    });
    this.getAllCompanyProducts();
    // this.FetchUsersRecentsPointsEarned();
    this.FetchUsersRecentsPointsEarned(1);
    window.addEventListener("scroll", this.handleScroll);
    const { getUserRewardDetails } = this.props;
    getUserRewardDetails();
    // getCompanyRewardTierAPI(companyId);
  }



  handleScroll = () => {
    const { loadingMore, currentPage, lastPage } = this.state;
  
    if (loadingMore) return;
    if (currentPage >= lastPage) return;
  
    const scrollTop = window.scrollY;
    const windowHeight = window.innerHeight;
    const fullHeight = document.documentElement.scrollHeight;
  
    if (scrollTop + windowHeight >= fullHeight - 100) {
      this.setState(
        { loadingMore: true },
        () => this.FetchUsersRecentsPointsEarned(currentPage + 1)
      );
    }
  };


  tableData = [
    {
      id: 1,
      description: "Spot Points",
      bucket: "Reward",
      xp: 50,
      date: "Jan 19, 2026",
    },
    {
      id: 2,
      description: "Biometric Screening",
      bucket: "Health Hub",
      xp: 50,
      date: "Oct 18, 2025",
    },
  ];


  getAllCompanyProducts = async()=>{
    const { userId, admin } = this.props;
    let finalUserId = userId;
    if (admin) {
      const pathParts = window.location.pathname.split("/");
      finalUserId = pathParts[3]; 
    }
    const url = `${GetUserRewardData}?user_id=${finalUserId}`;
    try {
      const res = await fetchApi(url , "GET");
      if (res.status === "success") {
        this.setState({rewardData: res?.data,isRewardLoading: false})
        
      } else {
        toast.error(res.error);
        this.setState({ isRewardLoading: false });
      }
    } catch (error) {
      window.console.error(error);
      this.setState({ isRewardLoading: false });
    }
  }





  ExperienceTable = () => {
    window.console.log("")
    const {bucketPointsData} = this.state;
    return (
      <>
        <TableWrapper>
          {/* Header */}
          <TableHeader>
            <div className="headingText , descWidth">Description</div>
            <div className="headingText">Bucket</div>
            <div className="headingText">XP Earned</div>
            <div className="headingText">Date</div>
          </TableHeader>
    
          {/* Rows */}
          <div style={{padding:"0px 20px"}}>
            {bucketPointsData?.reward_records?.map((item) => (
              <TableRow key={item.id}>
                <div className="description , descWidth">{item.points_description}</div>
                <div className="description">{item.bucket}</div>
                <div className="description">
                  {item.points_earned} XP
                </div>
                <div className="description">{dayjs(item.awarded_at).format("MMM DD, YYYY")}</div>
              </TableRow>
            ))}
          </div>
    
        </TableWrapper>
      </>
    );
  };



  FetchUsersRecentsPointsEarned = async (page = 1) => {
    try {
      const perPage = 50;
      const { userId, admin } = this.props;
      let finalUserId = userId;
      if (admin) {
        const pathParts = window.location.pathname.split("/");
        finalUserId = pathParts[3]; 
      }
      const url = `${GetUsersRecentsPointsEarned}?page_no=${page}&per_page=${perPage}&user_id=${finalUserId}`;
      const res = await fetchApi(url, "GET");
  
      if (res.status === "success") {
        this.setState((prevState) => ({
          bucketPointsData: {
            reward_records:
              page === 1
                ? res.data.reward_records
                : [
                  ...prevState.bucketPointsData.reward_records,
                  ...res.data.reward_records,
                ],
          },
          currentPage: res.data.pagination.current_page,
          lastPage: res.data.pagination.last_page,
          loadingMore: false,
        }));
      } else {
        toast.error(res.error);
      }
    } catch (error) {
      window.console.error(error);
    }
  };

  getTierAchievement = (tierName) => {
    const { rewardData } = this.state;
  
    return rewardData?.user_reward_tier_achievements?.find(
      (item) => item.tier?.toLowerCase() === tierName.toLowerCase()
    );
  };
  
  formatMonth = (dateString) => {
    if (!dateString) return "";
    return new Date(dateString).toLocaleDateString("en-US", {
      month: "long",
    });
  };



  //   FetchUsersRecentsPointsEarned = async () => {
  //     try {
  //       const pageNo = 1;
  //       const perPage = 50;
  //       const userId = 2;
    
  //       const url = `${GetUsersRecentsPointsEarned}?page_no=${pageNo}&per_page=${perPage}&user_id=${userId}`;
    
  //       const res = await fetchApi(url, "GET");
    
  //       window.console.log("GetUsersRecentsPointsEarned", res);
    
  //       if (res.status === "success") {
  //         this.setState({ bucketPointsData: res?.data });
  //       } else {
  //         toast.error(res.error);
  //       }
  //     } catch (error) {
  //       window.console.error(error);
  //     }
  //   };


  renderTrophy = (title, points, image, achievement, margin) => (
    <TrophyImg margin={margin}>
      <LazyImage div={'image-container'} src={image} />
  
      <TrophyLabel>
        {achievement?.is_achieved
          ? `${title} ${commaSeperator(points)} XP`
          : title}
      </TrophyLabel>
  
      <TrophyPoints>
        {achievement?.is_achieved
          ? `Completed in ${this.formatMonth(achievement?.achieved_date)}`
          : `${commaSeperator(points)} XP`}
      </TrophyPoints>
    </TrophyImg>
  );
  

  render() {
    const { reward, t/* fitnessDetails, socialDetails, wellnessDetails, educationDetails, bonusWellness, bonusSocial, bonusEducation, bonusFitness, companyRewardsBarValues*/} = this.props;
    const {rewardData,isRewardLoading,bucketPointsData} = this.state;
    const currentMonthsPoints = rewardData?.user_reward_tier_achievements?.[0]?.points_earned_in_current_month || 0;

    if(!reward || _.isUndefined(rewardData)) {
      return <Waiting />
    }
    if (isRewardLoading) {
      return (
        <SkeletonLoder width={"100%"} height={"400px"} style={{margin:"25px 0px"}}/>
      );
    }
    let finishPoint = rewardData?.company_reward_active_thresholds?.finished;
    const bronzePoints = !_.isUndefined(rewardData?.company_reward_active_thresholds?.bronze) ? rewardData.company_reward_active_thresholds?.bronze:0;
    const silverPoints = !_.isUndefined(rewardData?.company_reward_active_thresholds?.silver)? rewardData.company_reward_active_thresholds?.silver:0;
    const goldPoints = !_.isUndefined(rewardData?.company_reward_active_thresholds?.gold)?rewardData.company_reward_active_thresholds?.gold:0;
    // const bronze =  bronzePoints/finishPoint*100;
    // const silver = silverPoints/finishPoint*100;
    // const gold = goldPoints/finishPoint*100;
    const points = rewardData?.user_total_points_sum || 0;

    const bronzeAchievement = this.getTierAchievement("Bronze");
    const silverAchievement = this.getTierAchievement("Silver");
    const goldAchievement = this.getTierAchievement("Gold");
    const platinumAchievement = this.getTierAchievement("Platinum");
    
   
    // const {  monthlyRewardPoint } = this.props;

    // const currentMonthReward = rewardData
    const date = new Date();
    const month =  findMonth(date.getMonth());    
    let progressData = {};
    progressData.point = rewardData?.user_total_points_sum === finishPoint ? finishPoint : rewardData?.user_total_points_sum > finishPoint ? finishPoint : rewardData?.user_total_points_sum >= goldPoints+1 ? finishPoint- rewardData?.user_total_points_sum : rewardData?.user_total_points_sum >= silverPoints+1 ? (goldPoints)- rewardData?.user_total_points_sum: rewardData?.user_total_points_sum < bronzePoints ? bronzePoints- rewardData?.user_total_points_sum : (silverPoints)- rewardData?.user_total_points_sum;
    progressData.level = rewardData?.user_total_points_sum >finishPoint ? '' : rewardData?.user_total_points_sum < bronzePoints ? 'bronze' : rewardData?.user_total_points_sum < silverPoints ? 'silver' : rewardData?.user_total_points_sum < goldPoints ? 'gold' : rewardData?.user_total_points_sum <  finishPoint ? 'Finished' : rewardData?.user_total_points_sum ===  finishPoint ? 'Finished' : '';

    const earnedPoints=Number(rewardData?.user_total_points_sum) || 0;
    const userTier = earnedPoints >= rewardData?.company_reward_active_thresholds?.finished ? 'finished' : earnedPoints >= rewardData?.company_reward_active_thresholds?.gold ? 'gold' : earnedPoints >= rewardData?.company_reward_active_thresholds?.silver ? 'silver' : earnedPoints >= rewardData?.company_reward_active_thresholds?.bronze ? 'bronze' :earnedPoints >= rewardData?.company_reward_active_thresholds?.silver ? 'none' : null;

    const tierKey = userTier || 'none';
    const tierStyle = TIER_STYLES[tierKey] || TIER_STYLES?.none;

    const getProgressWidth = () => {
      if (!points) return 0;
      // BRONZE
      if (points < bronzePoints) {
        return (points / bronzePoints) * 3.5;
      }
    
      // SILVER (Bronze earned)
      if (points < silverPoints) {
        return (
          10.7 +
          ((points - bronzePoints) / (silverPoints - bronzePoints)) *
            (32.9 - 10.7)
        );
      }
    
      // GOLD (Silver earned)
      if (points < goldPoints) {
        return (
          40.4 +
          ((points - silverPoints) / (goldPoints - silverPoints)) *
            (62 - 40.4)
        );
      }
    
      // PLATINUM (Gold earned)
      if (points < finishPoint) {
        return (
          70 +
          ((points - goldPoints) / (finishPoint - goldPoints)) *
            (93 - 70)
        );
      }
      // PLATINUM earned
      return 100;
    };
    const progressWidth = Math.min(Math.max(getProgressWidth(), 0), 100);
    const totalPoints = Number(rewardData?.user_total_points_sum) || 0;
    

    return (
      <div>
        <Layout>
          <NewProgressCard >
            <NewProgressContent tierStyle={tierStyle}>
              <div className='main_content'>
              
                <div className="newImageData">
                  {/* <ImageTag>
                    <LazyImage src={ rewardData?.user_total_points_sum >= rewardData?.company_reward_active_thresholds?.finished ?  `${ImageUrl}/images/Rewards/new-platinum.png` : rewardData?.user_total_points_sum > goldPoints ? `${ImageUrl}/images/Rewards/new-gold.png` : rewardData?.user_total_points_sum > silverPoints ? `${ImageUrl}/images/Rewards/new-silver.png` :  rewardData?.user_total_points_sum> bronzePoints ? `${ImageUrl}/images/Rewards/new-bronze.png` : `${ImageUrl}/images/Rewards/new-no-badge.png`}/>
                </ImageTag> */}

                  <ImageTag>
                    <LazyImage
                      src={
                        totalPoints === 0
                          ? `${ImageUrl}/images/Rewards/new-no-badge.png`
                          : totalPoints >= rewardData?.company_reward_active_thresholds?.finished
                            ? `${ImageUrl}/images/Rewards/new-platinum.png`
                            : totalPoints >= goldPoints
                              ? `${ImageUrl}/images/Rewards/new-gold.png`
                              : totalPoints >= silverPoints
                                ? `${ImageUrl}/images/Rewards/new-silver.png`
                                : totalPoints >= bronzePoints
                                  ? `${ImageUrl}/images/Rewards/new-bronze.png`
                                  : `${ImageUrl}/images/Rewards/new-no-badge.png`
                      }
                    />
                  </ImageTag>
                </div> 
                <div className='main_point_class'>
                  <div className='point_class'>
                    <div className='total_value'>{t("Total XP Earned")}</div>
                    <div className='total_point_value'>{commaSeperator(rewardData?.user_total_points_sum)}</div>
                    <div className='left_point'>{currentMonthsPoints} {t("points earned in")} {t(month)}</div>
                  </div>
                </div>
              </div>
            </NewProgressContent>
            <NewProgressPoints style={{position:'relative'}}>
              <MainProgressBar style={{position:'absolute',display:'flex', height:'100%',top:'15%'}}>
                <ProgressBar 
                  width={progressWidth} 
                  color={'#DA6C74'}>
                  <div className="progrss" />
                </ProgressBar>
              </MainProgressBar>
              <div className="medals-container">

                {/* <TrophyImg margin={'0px 0px 0px 25px'}>
                  <LazyImage div={'image-container'} src={`${ImageUrl}/images/Rewards/new-bronze.png`} />
                  {!bronzeAchievement?.is_achieved ? (
                    <>
                      <TrophyLabel>Bronze</TrophyLabel>
                      <TrophyPoints>{commaSeperator(bronzePoints)} XP</TrophyPoints>
                    </>
                  ) : (
                    <>
                      <TrophyLabel>
                        Bronze {commaSeperator(bronzePoints)} XP
                      </TrophyLabel>
                      <TrophyPoints>
                        Completed in {this.formatMonth(bronzeAchievement?.achieved_date)}
                      </TrophyPoints>
                    </>
                  )}
                </TrophyImg> */}

                {this.renderTrophy("Bronze", bronzePoints, `${ImageUrl}/images/Rewards/new-bronze.png`, bronzeAchievement)}
                {this.renderTrophy("Silver", silverPoints, `${ImageUrl}/images/Rewards/new-silver.png`, silverAchievement)}

                {this.renderTrophy("Gold", goldPoints, `${ImageUrl}/images/Rewards/new-gold.png`, goldAchievement)}
                
                {this.renderTrophy(
                  "Platinum",
                  rewardData?.company_reward_active_thresholds?.finished,
                  `${ImageUrl}/images/Rewards/new-platinum.png`,
                  platinumAchievement,
                  '0px -3px 0px 0px'
                )}
                {/* <TrophyImg>
                  <LazyImage
                    div={'image-container'}
                    src={`${ImageUrl}/images/Rewards/new-silver.png`}
                  />
                
                  <TrophyLabel>
                    {silverAchievement?.is_achieved
                      ? `Silver ${commaSeperator(silverPoints)} XP`
                      : "Silver"}
                  </TrophyLabel>
                
                  <TrophyPoints>
                    {silverAchievement?.is_achieved
                      ? `Completed in ${this.formatMonth(silverAchievement?.achieved_date)}`
                      : `${commaSeperator(silverPoints)} XP`}
                  </TrophyPoints>
                </TrophyImg> */}
                {/* <TrophyImg>
                  <LazyImage div={'image-container'} src={`${ImageUrl}/images/Rewards/new-silver.png`} />
                  <TrophyLabel>Silver</TrophyLabel>
                  <TrophyPoints>{commaSeperator(silverPoints)} XP</TrophyPoints>
                </TrophyImg> */}

                {/* <TrophyImg>
                  <LazyImage div={'image-container'} src={`${ImageUrl}/images/Rewards/new-gold.png`} />
                  <TrophyLabel>Gold</TrophyLabel>
                  <TrophyPoints>{commaSeperator(goldPoints)} XP</TrophyPoints>
                </TrophyImg>

                <TrophyImg margin={'0px -3px 0px 0px'}>
                  <LazyImage div={'image-container'} src={`${ImageUrl}/images/Rewards/new-platinum.png`} />
                  <TrophyLabel>Platinum</TrophyLabel>
                  <TrophyPoints>{commaSeperator(rewardData?.company_reward_active_thresholds?.finished)} XP</TrophyPoints>
                </TrophyImg> */}

                {/* 
                <TrophyImg>
                  <LazyImage
                    div={'image-container'}
                    src={`${ImageUrl}/images/Rewards/new-gold.png`}
                  />
                
                  <TrophyLabel>
                    {goldAchievement?.is_achieved
                      ? `Gold ${commaSeperator(goldPoints)} XP`
                      : "Gold"}
                  </TrophyLabel>
                
                  <TrophyPoints>
                    {goldAchievement?.is_achieved
                      ? `Completed in ${this.formatMonth(goldAchievement?.achieved_date)}`
                      : `${commaSeperator(goldPoints)} XP`}
                  </TrophyPoints>
                </TrophyImg>



                <TrophyImg margin={'0px -3px 0px 0px'}>
                  <LazyImage
                    div={'image-container'}
                    src={`${ImageUrl}/images/Rewards/new-platinum.png`}
                  />
                
                  <TrophyLabel>
                    {platinumAchievement?.is_achieved
                      ? `Platinum ${commaSeperator(
                        rewardData?.company_reward_active_thresholds?.finished
                      )} XP`
                      : "Platinum"}
                  </TrophyLabel>
                
                  <TrophyPoints>
                    {platinumAchievement?.is_achieved
                      ? `Completed in ${this.formatMonth(platinumAchievement?.achieved_date)}`
                      : `${commaSeperator(
                        rewardData?.company_reward_active_thresholds?.finished
                      )} XP`}
                  </TrophyPoints>
                </TrophyImg> */}

              </div>
              <PointContent />
            </NewProgressPoints>
          </NewProgressCard>

          

          <Disclaimer>Disclaimer: Points for your Steps, Calories, and Device Minutes Log will be calculated and added at the end of each month.</Disclaimer>
          {bucketPointsData?.reward_records?.length ?  <this.ExperienceTable  /> : null}
          {this.state.loadingMore && (
            <div style={{ textAlign: "center", padding: "10px",color:"#184A61",fontWeight:"700"}}>
              Loading more...
            </div>
          )}
          {/* <CategoryContainer>
            { categoryArray.map((category, index) => (
              <>
                <NewRewardCatagory category={category} key={index} history={this.props.history} monthlyRewardPoint={this.props.monthlyRewardPoint}  getIndex={index}/>
              </>
            ))}
          </CategoryContainer>    */}
        </Layout>
      </div>
    );
  }
}

RewardDetailsPage.propTypes = {
  reward: PropTypes.object,
  monthlyRewardPoint: PropTypes.number,
  fitnessDetails: PropTypes.array,
  socialDetails: PropTypes.array,
  wellnessDetails: PropTypes.array,
  educationDetails: PropTypes.array,
  bonusWellness: PropTypes.array,
  bonusSocial: PropTypes.array,
  getUserRewardDetails: PropTypes.func,
  history: PropTypes.object,
  bonusFitness: PropTypes.array,
  bonusEducation: PropTypes.array,
  t: PropTypes.func,
  // getCompanyRewardTierAPI: PropTypes.func,
  // companyRewardsBarValues: PropTypes.array,
  companyId: PropTypes.number,
  userId: PropTypes.number,
  getHistoryRewardPoints: PropTypes.func,
  rewardData: PropTypes.array,
  companyBranding: PropTypes.object,
  admin: PropTypes.bool,
};

const mapStateToProps = (state) => ({
  reward: state.wellnessDashboard.reward,
  monthlyRewardPoint: state.wellnessDashboard.monthlyRewardPoint,
  fitnessDetails: state.wellnessDashboard.fitnessDetails,
  socialDetails: state.wellnessDashboard.socialDetails,
  wellnessDetails: state.wellnessDashboard.wellnessDetails,
  educationDetails: state.wellnessDashboard.educationDetails,
  bonusWellness: state.wellnessDashboard.bonusWellness,
  bonusSocial: state.wellnessDashboard.bonusSocial,
  bonusFitness: state.wellnessDashboard.bonusFitness,
  bonusEducation: state.wellnessDashboard.bonusEducation,
  // companyRewardsBarValues: state.wellnessDashboard.companyRewardsBarValues,
  userId: state.profileData.userId,
  rewardData: state.wellnessDashboard.rewardData,
  companyBranding: state.wellnessDashboard.companyBrandingDetails,
});

const mapDispathcToProps = (dispatch) => ({
  getUserRewardDetails: () => dispatch(getUserRewardDetails()),
  // getCompanyRewardTierAPI: (companyId) => dispatch(getCompanyRewardTierAPI(companyId))
})

export default connect(mapStateToProps, mapDispathcToProps)(withTranslation()(RewardDetailsPage));